import React from 'react';
import { Lock } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './tooltip';

/**
 * Lock overlay for restricted features.
 * Shows lock icon with hover message (e.g. "Contact admin").
 */
const RestrictedOverlay = ({ message = 'Contact admin', children, className = '' }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`relative flex items-center justify-center min-h-[200px] bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 cursor-not-allowed ${className}`}
            onClick={(e) => e.preventDefault()}
          >
            <div className="flex flex-col items-center gap-2 text-gray-500">
              <Lock size={48} className="text-red-500" />
              <span className="text-sm font-medium">Access Restricted</span>
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p>{message}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RestrictedOverlay;
